import React from 'react';
import { View, Text, Platform } from 'react-native';
import { Button, Icon } from 'react-native-elements';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { DatePickerModal, TimePickerModal } from 'react-native-paper-dates';
import moment from 'moment-timezone';
import { styles } from 'styles/components/dateInput';
import DateInputProps from 'types/components/DateInputProps';

export default ({ text, onChange, isMediumScreen }: DateInputProps): JSX.Element => {
  const [date, setDate] = React.useState<any>();
  const [open, setOpen] = React.useState(false);
  const [openTime, setOpenTime] = React.useState(false);
  const [time, setTime] = React.useState<any>({ hours: 0, minutes: 0 });
  const [formatedDate, setFormatedDate] = React.useState<string | Date | null>(null);

  const onDismissSingle = React.useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const onConfirmSingle = React.useCallback(
    (params: any) => {
      setOpen(false);
      setDate(params.date);
      setOpenTime(true);
    },
    [setOpen, setDate],
  );

  const onDismissTime = React.useCallback(() => {
    setOpenTime(false);
  }, [setOpen]);

  const onConfirmTime = React.useCallback(
    (params: { hours: number; minutes: number }) => {
      setOpenTime(false);
      if (params) setTime(params);
    },
    [setOpenTime, setTime],
  );

  React.useEffect(() => {
    if (date && time) {
      setOpen(false);
      const concatTimeToDate = `${moment(date).format('YYYY/MM/DD')} ${time.hours}:${time.minutes}`;
      setFormatedDate(concatTimeToDate);
      onChange(concatTimeToDate);
    }
  }, [time]);

  return (
    <>
      {Platform.OS === 'web' ? (
        <>
          <View style={{ marginHorizontal: 5 }}>
            <Text style={styles.alignText}>{`${text}`}</Text>
            {React.createElement('input', {
              type: 'datetime-local',
              value: formatedDate ?? '',
              onInput: (event: any) => {
                const date = moment(event.target.value).format('yyyy-MM-DD[T]HH:mm');
                setFormatedDate(date);
                onChange(event.target.value);
              },
              style: styles.datetimeWeb,
            })}
          </View>
        </>
      ) : (
        <SafeAreaProvider style={[{ maxWidth: isMediumScreen ? 180 : 250 }]}>
          <View style={[styles.wrapper, isMediumScreen && { marginRight: 20 }]}>
            <View>
              <Text style={styles.alignText}>{`${text}`}</Text>
              <Button
                onPress={() => setOpen(true)}
                buttonStyle={styles.button}
                style={styles.buttonContainer}
                title={
                  <View style={styles.dateContainer}>
                    <Icon name="calendar" type="ionicon" color="#3f3a40" size={24} />
                    <Text style={styles.dateText}>{`${formatedDate ? formatedDate : 'aaaa/mm/dd hh:mm'}`}</Text>
                  </View>
                }
                type="outline"
              ></Button>
            </View>
            <DatePickerModal
              locale="es"
              mode="single"
              visible={open}
              onDismiss={onDismissSingle}
              date={date}
              onConfirm={onConfirmSingle}
            />
            <TimePickerModal
              locale="es"
              visible={openTime}
              hours={0o0}
              minutes={0o0}
              onDismiss={onDismissTime}
              onConfirm={onConfirmTime}
            />
          </View>
        </SafeAreaProvider>
      )}
    </>
  );
};
